module.exports = __webpack_public_path__ + "static/media/index-popup-send-bg.ed5dcc38.png";